import logo from '../../Designs/rjknack3.png';

const HeaderLogo = ({classCss}) => {
	return (
		<img src={logo} className={classCss}  height={'auto'}/>
	);
};

export default HeaderLogo;